import {Injectable, inject} from '@angular/core';
import {ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree} from '@angular/router';
import {Observable, of} from 'rxjs';
import {AuthenticationService} from '../_services/authentication.service';
import {mergeMap, tap} from 'rxjs/operators';

/**
 * A guard that checks if a user is logging in for the first time before allowing the router to navigate to a specific route.
 * If it is the first-time-log in, redirect the user to the first-time-login page.
 */
@Injectable({
  providedIn: 'root'
})
export class FirstLoginGuard  {
  private router = inject(Router);
  private authenticationService = inject(AuthenticationService);


  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> {
    return this.authenticationService.isFirstTimeUser$.pipe(
      tap((isNewUser: boolean) => {
        if(isNewUser) {
          console.info('New user.  Sending to first time login.');
        }
      }),
      mergeMap((isNewUser: boolean) => isNewUser && of(this.router.parseUrl('/first-time-login')) || of(true))
    );
  }

}
